import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
//import { Col } from 'react-bootstrap/Form'
import { Form, Card, Button, Col, Jumbotron, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Menu from './menu'
import errores from '../middleware/errordb'
import back from '../back.svg';
import config from '../config';
import Mensajes from './subcomponent/mensajes';
import ModalConfirm from './subcomponent/modalConfirm';

class FormularioUsuario extends Component {
    constructor(props) {
        super(props);
        //const usuarioMofificar = this.props
        const currentCompany = sessionStorage.getItem('company');
        const nombre_usuario = sessionStorage.getItem('usuario');
        const currentUserType = sessionStorage.getItem('tipo');
        const currentUser = sessionStorage.getItem('_id');
        this.state = {
            titulo: "Crear Usuarios",
            mostrarMensaje: false,
            msg: 0,
            comp: "",
            empresa: currentCompany,
            codEmp: "",
            nombre: "",
            id_usuario: "",
            usuario: "",
            password: "",
            tipo: currentUserType,
            usuario_login: currentUser,
            currentUserName: nombre_usuario,
            estado: "1",
            tipo_usuario: "1",
            mensaje: "",
            vendedores: [],
            vendedor_asociado: "0",
            isfacele: false,
            iscatalogo: false,
            isestrutura: false,
            isventas: false,
            ispedido: false,
            isinventario: false,
            activefacele: true,
            activecatalogo: true,
            activeestrutura: true,
            activeventas: true,
            activepedido: true,
            activeinventario: true
        }
    }

    componentDidMount() {
        const { usuario_login } = this.state;
        const datasend = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'empresa': this.state.empresa
            }
        }
        fetch(config.servBackEnd + '/clients/ingresocust/' + usuario_login, datasend).then(response => response.json())
            .then(data => {
                if (data.ok) {
                    const datos = data.data;
                    const usuarioClient = datos[0];
                    this.setState({
                        password: usuarioClient.PASS_CLIENTE
                    })
                }
            });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({ show: true });
    }

    enviarInfo = () => {
        this.setState({ show: false });
        const { empresa } = this.state;
        const { password } = this.state;
        const datasend = {
            method: 'POST',
            body: JSON.stringify({
                password,
                empresa
            }),
            headers: {
                'Content-Type': 'application/json',
                'tipo': this.state.tipo,
            }
        }
        fetch(config.servBackEnd + '/clients/modifyCust/' + this.state.usuario_login, datasend).then(response => response.json())
            .then(data => {
                ////console.log(data);
                if (data.ok) {
                    const nuevoUsuario = (data.data.insertId !== 0) ? data.data.insertId : this.state.usuario_login;
                    this.setState({ mostrarMensaje: true, mensaje: "Tarea Finalizada correctamente", usuario_login: nuevoUsuario });
                } else {
                    this.setState({ mostrarMensaje: true, mensaje: "Usuario con errores:" + errores[data.code] + " " + data.message })
                }
                //this.s
                //this.setState({ data })
            });
        //});
        event.preventDefault();
    }

    CheckedPerm = ({ target }) => {
        const { id } = target;
        const { checked } = target;
        this.setState({ [id]: checked });
    }

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        const mensajeConfirm = (this.state.id_usuario === "") ? '¿Esta seguro que desea crear el usuario?' : '¿Esta seguro que desea modificar el usuario?';



        return (
            <div className="FormularioUsuario">
                <Menu></Menu>
                <div>
                    <ModalConfirm show={this.state.show} enviarInfo={this.enviarInfo} handleClose={this.handleClose} mensaje={mensajeConfirm} ></ModalConfirm>
                </div>
                <Jumbotron className="Jumbotron">
                    <h2>Modificar Cliente</h2>
                </Jumbotron>
                <div>
                    <OverlayTrigger placement='top-start' overlay={<Tooltip>Volver a Usuarios!</Tooltip>}>
                        <div className="div-back">
                            <a href="/usuarios/">
                                <img src={back} className="icon" alt="" />
                            </a>
                        </div>
                    </OverlayTrigger>

                    <Card className="card">
                        <Card.Body>
                            <Form className="form" onSubmit={this.handleSubmit}>
                                <Form.Row>
                                    <Form.Control type="hidden" value={this.state.id_usuario} required disabled />
                                    <Form.Group as={Col} controlId="formGridEmpresa">
                                        <Form.Label>Empresa</Form.Label>
                                        <Form.Control type="text" placeholder="Empresa" onChange={e => this.setState({ empresa: e.target.value })} value={this.state.empresa} required disabled />
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formGridNombre">
                                        <Form.Label>Nombre</Form.Label>
                                        <Form.Control type="text" placeholder="Nombre" onChange={e => this.setState({ nombre: e.target.value.toUpperCase() })} value={this.state.currentUserName} disabled />
                                    </Form.Group>

                                    <Form.Group as={Col} controlId="formGridUsuario">
                                        <Form.Label>Usuario</Form.Label>
                                        <Form.Control type="text" placeholder="Usuario" onChange={e => this.setState({ usuario: e.target.value })} value={this.state.usuario_login} disabled />
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="formGridCodigoPassword">
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control type="password" placeholder="Password" onChange={e => this.setState({ password: e.target.value })} value={this.state.password} />
                                    </Form.Group>
                                </Form.Row>
                                <Button variant="primary" type="submit">Modificar</Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>

                <Mensajes estado={this.state.mostrarMensaje} mensaje={this.state.mensaje} ocultar={() => this.setState({ mostrarMensaje: false })} ></Mensajes>
            </div>
        );
    }
}
export default (FormularioUsuario);





